import React from 'react';
import { BarChart3Icon, CoinsIcon, RecycleIcon, SearchIcon, SparklesIcon } from 'lucide-react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { compoundBenefits, compoundFeatures, controlTowerScreenshot, controlTowerSource } from '../../../data/deck';
import type { CompoundIcon, Crop } from '../../../data/deck';
const ICONS: Record<CompoundIcon, React.ComponentType<{
  className?: string;
}>> = {
  see: BarChart3Icon,
  learn: SparklesIcon,
  reuse: RecycleIcon,
  spot: SearchIcon,
  buy: CoinsIcon
};
export function CompoundSlide() {
  return <Slide id="compound" data-id="element-160" data-mp="2mdl2z72myzfl">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_440px] lg:gap-16" data-id="element-161" data-mp="2mc9yt65a3pny">
        <InView data-id="element-162" data-mp="2r4b60dnlaq74">
          <h2 className="font-display text-[44px] font-semibold leading-[0.98] tracking-[-0.03em] text-navy sm:text-[60px] xl:text-[70px]" data-id="element-163" data-mp="2r4tce33yuksr">
            One Snak is a campaign.
            <span className="block text-navy/40" data-id="element-164" data-mp="1ymywhk8a5n7p">Many Snaks compound.</span>
          </h2>
        </InView>
        <InView delay={0.06} data-id="element-165" data-mp="37vskofz2eiah">
          <p className="border-l-2 border-mint pl-5 text-[14.5px] leading-[1.7] text-navy/65" data-id="element-166" data-mp="37w2bg5rxoth8">
            <span className="text-navy" data-id="element-167" data-mp="33vs4oqwbhz1b">
              The Control Tower connects independent local activity. The digital team sees what’s working and
              proactively recommends
            </span>{' '}
            — local teams keep control of their campaigns and budgets.
          </p>
        </InView>
      </div>

      <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-168" data-mp="2p3zsuovqf34c">
        {compoundFeatures.map((feature, i) => {
        const Icon = ICONS[feature.key];
        return <InView key={feature.key} delay={0.1 + i * 0.06} y={26} data-id="element-169" data-mp="2g67lc6w94zri" data-mpi={i}>
              <figure className="h-full rounded-[28px] bg-canvas2 p-5 sm:p-6" data-id="element-170" data-mp="2b7cwooblsgzh">
                <div className="flex items-center gap-4" data-id="element-171" data-mp="ee18weni3yc9">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[14px] bg-navy text-mint" data-id="element-172" data-mp="edjelnkefu6z">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-173" data-mp="sjuvdkbwdmo1" />
                  </span>
                  <div data-id="element-174" data-mp="si08w1kz9mhu">
                    <span className="block text-[12px] font-semibold uppercase tracking-[0.2em] text-navy" data-id="element-175" data-mp="xabbjc73rme3">
                      {feature.title}
                    </span>
                    <span className="mt-0.5 block text-[13.5px] text-navy/60" data-id="element-176" data-mp="jhbsj0843a1s">{feature.detail}</span>
                  </div>
                </div>
                <div className="mt-5 overflow-hidden rounded-[16px] bg-paper p-2 ring-1 ring-navy/[0.08]" data-id="element-177" data-mp="1c7kbuvedw0hy">
                  <CroppedShot crop={feature.crop} alt={feature.alt} data-id="element-178" data-mp="1g8e05pvqnhbd" />
                </div>
              </figure>
            </InView>;
      })}
      </div>

      <ul className="mt-5 grid gap-5 md:grid-cols-3" data-id="element-179" data-mp="178hapm1iyef9">
        {compoundBenefits.map((benefit, i) => {
        const Icon = ICONS[benefit.key];
        return <li key={benefit.title} data-id="element-180" data-mp="3n1yeawr5ir62" data-mpi={i}>
              <InView delay={0.24 + i * 0.04} className="flex h-full items-center gap-4 rounded-[22px] bg-paper px-5 py-5 ring-1 ring-navy/[0.08]" data-id="element-181" data-mp="3rzhq7q0dmruu">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mint text-navy" data-id="element-182" data-mp="3fgvudd4wvo3q">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="3tf2ku87j6ltd" />
                </span>
                <span data-id="element-184" data-mp="3ogiu7uhzsluo">
                  <span className="block text-[12px] font-semibold uppercase tracking-[0.18em] text-navy" data-id="element-185" data-mp="3oic6bpbdjya2">
                    {benefit.title}
                  </span>
                  <span className="mt-0.5 block text-[13px] text-navy/60" data-id="element-186" data-mp="2wqeg2dktsv1w">{benefit.detail}</span>
                </span>
              </InView>
            </li>;
      })}
      </ul>
    </Slide>;
}
function CroppedShot({
  crop,
  alt
}: {
  crop: Crop;
  alt: string;
}) {
  return <div className="relative overflow-hidden rounded-[10px]" style={{
    aspectRatio: `${crop.width} / ${crop.height}`
  }} data-id="element-187" data-mp="2i0yrn48rp1pd">
      <img src={controlTowerScreenshot} alt={alt} className="absolute block max-w-none" style={{
      width: `${controlTowerSource.width / crop.width * 100}%`,
      left: `-${crop.x / crop.width * 100}%`,
      top: `-${crop.y / crop.height * 100}%`
    }} data-id="element-188" data-mp="2d2f1ssr1z5rq" />
    </div>;
}